import { render } from "./MessageImproveModal.vue?vue&type=template&id=79c64d7a"
import script from "./MessageImproveModal.vue?vue&type=script&lang=js"
export * from "./MessageImproveModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__